module.exports = __webpack_public_path__ + "img/1560423117.4e33c357.jpg";